<script>
// import Layout from './components/'
import SectionIntroduction from './components/SectionIntroduction'
import ScetionAdvantage from './components/ScetionAdvantage'
import AboutLayout from './components/MenuList'

export default {
  page() {
    return {
      title: `公司簡介 | 關於零壹`,
    }
  },
  components: {
    SectionIntroduction,
    ScetionAdvantage,
    AboutLayout,
  },
  props: {
    aboutCompany: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {}
  },
}
</script>
<template>
  <AboutLayout>
    <SectionIntroduction v-if="aboutCompany" :about-company="aboutCompany"></SectionIntroduction>
    <ScetionAdvantage v-if="aboutCompany" :about-company="aboutCompany"></ScetionAdvantage>
  </AboutLayout>
</template>
<style lang="scss" module>
</style>
